module.exports = __webpack_public_path__ + "static/about_us_2.879162b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/about/about_us_2.jpg
// module id = 382
// module chunks = 29096074603545 162898551421021